module.exports = __webpack_public_path__ + "img/sb.82f4f9c7.jpg";